<template>
  <div class='tabs-bar-wrapper' :class="className" :style="defaultStyle">
		<div ref="tabsBar" class="tabs-bar">
			<ul class="tabs-nav" ref="list">
				<li :ref="`li_${title.id}`" v-for="(title, index) in tabtitles" :class="[title.id === activeId ? 'active' : '']"  :key="title.id" @click="changeTab(title.id, index)" >
          <span :ref="`name_${title.id}`">{{title.name}}</span>
        </li>
				 <div class="tab-ink-bar-wrapper" :style="{ transform: inkBarPosition, webkitTransform: inkBarPosition, width: inktabWidth }">
					<span class="tab-ink-bar" :style="{width: defaultStyle.currentSelectedBottomLine || inkWidth}"></span>
				</div>
			</ul>
		</div>
  </div>
</template>

<script>
import op from 'object-path'
export default {
  name: "tab-bar",
  props: {
    tabtitles: {
      type: Array,
      required: true
    },
    defaultActiveId: [String, Number],
    className: String,
    maxTitleNum: {
      type: Number,
      default: 4
    },
    titleWidth: {
      type: [Number,String],
      default: 80
    },
    defaultStyle: {
      type: Object,
      default() {
        return {}
      },
    }
  },
  data() {
    return {
      activeId: "",
      tabsBarPosition: "",
      isMounted: false,
      inkWidth: "0px",
      // inkBarPosition: 0,
    };
  },
  updated() {
    if (this.activeId === "") {
      this.activeId = this.tabtitles[0].id;
    }
    const index = `name_${this.activeId}`
    if(this.tabtitles && this.$refs[index] && this.$refs[index].length) {
      this.inkWidth = `${this.$refs[index][0].offsetWidth}px`
    }
  },
  mounted() {
    this.activeId = this.defaultActiveId
    this.isMounted = true;
    const index = `name_${this.activeId}`
    const ref = this.$refs[index]
    if (ref) {
      this.inkWidth =  `${ref[0].offsetWidth}px`
    }

  },
  computed: {
    activeIndex() {
      return this.tabtitles.findIndex(el => el.id === this.activeId);
    },
    inkBarPosition() {
      const index = `li_${this.activeId}`
      const left = op(this.$refs).get(`${index}.0`) ? this.$refs[index][0].offsetLeft : 0
      return `translate3d(${left}px, 0px, 0px)`;
    },
    inktabWidth() {
      const index = `li_${this.activeId}`
      const width = op(this.$refs).get(`${index}.0`) ? this.$refs[index][0].offsetWidth : 58
      return `${width}px`
    },
    tabWidth() {
      if (!this.tabtitles.length) {
        return "";
      }
      if (this.tabtitles.length <= this.maxTitleNum) {
        return `${100 / this.tabtitles.length}%`;
      } else {
        return `${this.titleWidth}px`;
      }
    }
  },
  methods: {
    changeTab(id, index) {
      if (this.activeId !== id) {
        this.activeId = id;
      }
      this.$emit("changeTab", this.activeId);
      this.checkTabsBarPosition();
    },
    checkTabsBarPosition() {
      if (this.tabtitles.length <= this.maxTitleNum) {
        return;
      }
      const index = `li_${this.activeId}`
      const left = op(this.$refs).get(`${index}.0`) ? this.$refs[index][0].offsetLeft : 0
      this.$refs.tabsBar.scrollLeft = left;
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../stylesheet/variable";

@inkGrey: rgb(25, 26, 27);
@silverGrey: rgb(237, 237, 237);
@reddish: rgb(192, 49, 49);

.tabs-bar-wrapper {
  width: 100%;
  overflow-x: hidden;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  color: rgb(121, 125, 130);
  a {
    text-decoration: none;
  }
  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .tabs-bar {
    height: 30px;
    display: flex;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    transition: transform 0.2s cubic-bezier(0.35, 0, 0.25, 1);
    position: relative;
    &::-webkit-scrollbar {
      display: none;
    }

    .tabs-nav {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      width: 100%;
      li {
        padding: 0 15px;
        flex-shrink: 0;
        text-align: center;
        height: 16px;
        line-height: 16px;
        font-size: 14px;
        cursor: pointer;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
      .active {
        color: @reddish;
        font-size: 16px;
        font-weight: 500;
      }
      // span.active {
      //   color: @reddish;
      //   position: relative;
      //   &::after {
      //     content: "";
      //     position: absolute;
      //     width: 100%;
      //     border-bottom: 2px solid #c03131;
      //     border-radius: 2px;
      //     left: 0;
      //     bottom: -95%;
      //     transition: all 2s cubic-bezier(0.35, 0, 0.25, 1);
      //   }
      // }
      .tab-ink-bar-wrapper {
        position: absolute;
        margin: auto;
        top: 21px;
        left: 0;
        transform: translate3d(0px, 0px, 0px);
        transition: transform 0.2s cubic-bezier(0.35, 0, 0.25, 1);
        .tab-ink-bar {
          border-bottom: 2px solid #c03131;
          width: 26.5px;
          border-radius: 20px;
          display: block;
          margin: auto;
        }
      }
    }
  }
}
</style>
